module.exports = __webpack_public_path__ + "img/vertical_1_1_8019.844e995b.png";